/* eslint-disable class-methods-use-this */
/* eslint-disable no-restricted-syntax */
import MicroCMSAdapter from "./_MicroCMSAdapter";
import { makeNewsCard } from "./_card-utils";
import { HOME_NEWS_LIST_LIMIT, IS_DEBUG } from "./_constants";


export default class HomeApp {
  microCMSAdapter: MicroCMSAdapter

  constructor() {
    this.microCMSAdapter = new MicroCMSAdapter();
    this.setupNews();
  }

  setupNews() {
    const newsListElement = document.querySelector<HTMLElement>(
      ".p-home-section-news__news-list"
    );
    if (!newsListElement) {
      throw new Error("newsListElement is null");
    }
    this.microCMSAdapter.getNewsListAsync(1, HOME_NEWS_LIST_LIMIT).then((listResponse) => {
      const newsList = listResponse.contents;
      for (const news of newsList) {
        const newsElement = document.createElement("article");
        newsElement.classList.add("p-home-section-news__news");
        newsListElement.appendChild(newsElement);

        const cardElement = makeNewsCard(news);
        newsElement.appendChild(cardElement);
      }
      if (IS_DEBUG) {
        console.log(newsList);
      }
    }).catch((error) => {
      const errorElement = document.createElement("div");
      errorElement.classList.add("p-home-section-news__error");
      errorElement.textContent = `error.message: ${error.message}`;
      newsListElement.appendChild(errorElement);
      console.error(error);
    });

  }

}